import { useMutation } from "@tanstack/react-query";
import { postQuote } from "../actions/postQuoteCommercial";

interface GenerateQuotePayload {
  payload: any; // payload final (basic o advanced)
}
export const useGenerateQuoteMutation = (options?: { onSuccess?: () => void; onError?: () => void }) => {
  const token = sessionStorage.getItem("token");

  return useMutation({
    mutationFn: async ({ payload }: GenerateQuotePayload) => {
      return await postQuote(payload, token ?? "");
    },
    onSuccess: () => {
      options?.onSuccess?.();
    },
    onError: () => {
      options?.onError?.();
    },
  });
};
